import script from "./SupervisorMainSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisorMainSideBar.vue?vue&type=script&setup=true&lang=js"

import "./SupervisorMainSideBar.vue?vue&type=style&index=0&id=21d1bf94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d1bf94"]])

export default __exports__